import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What’s Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        Looking ahead, I am committed to my mission of promoting digital transformation and the
        growth it can facilitate.
      </p>
      <p>
        My current projects, including co-founding EMQ2, embody my dedication to empowering
        organizations to leverage technology for their benefit. I foresee a future where we can
        continue to build Digital Factories, cultivating a new generation of tech-savvy
        professionals, fostering innovation from within, and transforming organizations at their
        core.
      </p>

      <p>
        Whether you're interested in discussing potential opportunities, seeking advice, or simply
        curious about the realm of digital transformation, I welcome all inquiries. Let's connect
        and perhaps share insights over a cup of coffee or tea. I look forward to exploring the
        possibilities that our collaboration might bring.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Say Hello
      </a>
    </StyledContactSection>
  );
};

export default Contact;
